NtechApp.ViewBusinessAccAboutModalWorkingHoursForm = function($view) {
    var me = this;

    this._$view = null;
    this._click = null;

    this._form = null;
    this._$form = null;

    this._construct = function() {
        me._$view = $view;
        me._click = new NtechApp.TouchClickEvent();

        me._init();

        me._bindEvents();
    }

    this._bindEvents = function() {
        me._click.listen(me._$view, "[data-triggerShowWorkingHoursPopup]", function() {
            me._form.load("fakecacheroute");
        });
    }

    this._unbindEvents = function() {
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.ViewBusinessAccAboutModalWorkingHoursForm, {
    _init: function() {
        var me = this;

        me._form = new NtechApp.ModalForm(NtechApp.ModalForm.CACHE);
        me._form.setFormView($("#viewWorkingHours"));

        me._$form = $("body").find("#viewWorkingHours");
        
        me._bindFormEvents();
    },

    _bindFormEvents: function() {
        var me = this;

        this._click.listen(this._$form.find(".formHeader .close .button"), function() {
            me._form.unload();
        });

        this._click.listen(this._$form.find("[data-cancelBut]"), function() {
            me._form.unload();
        });

        this._click.listen(this._$form.find("[data-confirmBut]"), function() {
            me._form.unload();
        });
    }
});